// extracted by mini-css-extract-plugin
export default {"skeleton":"Uya40l","isBusy":"DfuAgB","skeleton-pulse":"OKoSmE"};